<template>
    <div>
        <multi-select
            ref="multiselect"
            :options="displayedOptions"
            :name="name"
            :placeholder="placeholder"
            :selected="selected"
            :selected-label="selectedLabel"
            :select-label="selectLabel"
            :deselect-label="deselectLabel"
        />

        <div v-if="showToggles">
            <a class="formGroup__toggle" href="#" v-if="showRelated" @click="showList($event, false)">{{ backupLabel }}</a>
            <a class="formGroup__toggle" href="#" v-else @click="showList($event, true)">{{ relatedLabel }}</a>
        </div>
    </div>
</template>



<script>
import MultiSelect from './MultiSelect.vue'

export default {

    /* Settings
    --------------------------------------------------------- */

    name: 'PosMultiselect',


    components: {
        MultiSelect,
    },


    props: {
        placeholder: { type: String, required: true },
        name: { type: String, required: true },
        options: { type: Array, required: true },
        selected: { type: Array, required: true },

        selectedLabel: { type: String, required: true },
        selectLabel: { type: String, required: true },
        deselectLabel: { type: String, required: true },

        backupLabel: { type: String, required: true },
        relatedLabel: { type: String, required: true },
    },


    data() {
        return {
            showRelated: true,
            showToggles: true,
        }
    },

    mounted() {
        if (!this.displayedOptions.length) {
            this.showToggles = false
            this.showRelated = false
            // wait multiselect updated with new option to update selected value
            this.$nextTick(() => {
                this.$refs.multiselect.rebindValue()
            })
        }
    },

    computed: {
        displayedOptions() {
            if (this.showRelated) {
                return this.options.filter(opt => opt.related)
            }
            return this.options
        },
    },


    methods: {
        showList(e, flag) {
            e.preventDefault()
            this.showRelated = flag
            this.$refs.multiselect.open()
        },
    },
}
</script>
